module.exports = "<ng-container *ngIf=\"variant === 'vertical-style-1'\">\r\n    <navbar-vertical-style-1></navbar-vertical-style-1>\r\n</ng-container>"